import React from "react";
import GitHubCalendar from "react-github-calendar";
import { Row } from "react-bootstrap";
import ScrollReveal from "../ScrollReveal/ScrollReveal";

function Github() {
  return (
    <Row style={{ justifyContent: "center" }}>
      <ScrollReveal className="section-intro compact center" distance={20}>
        <span className="section-kicker">Consistency</span>
        <h2>Code shipped over time, not in bursts.</h2>
      </ScrollReveal>
      <ScrollReveal className="gitContainer" delay={90} distance={22}>
        <GitHubCalendar
          username="shankarkharel"
          color="var(--clr-accent)"
          blockSize={13}
          blockMargin={5}
          fontSize={13}
        />
      </ScrollReveal>
    </Row>
  );
}

export default Github;
